import * as R from 'ramda';

const avgCycleTimeListData = (state: any) => R.pathOr([], ['myproductivity', 'averageCycleTimeList'], state)
const avgCycleTimeListTotalData = (state: any) => R.pathOr([], ['myproductivity', 'averageCycleTimeListTotal'], state);
const myProductivityListData = (state: any) => R.pathOr([], ['myproductivity', 'myProductivityList'], state);
const mySwingloadOccurrenceListData = (state: any) => R.pathOr([], ['myproductivity', 'mySwingloadOccurrenceList'], state);
const pmoTrucksListData = (state: any) => R.pathOr([], ['myproductivity', 'pmoTrucksList'], state);
const pmoTrucksMilesListData = (state: any) => R.pathOr([], ['myproductivity', 'pmoTrucksMilesList'], state);
const hdTrucksListData = (state: any) => R.pathOr([], ['myproductivity', 'hdTrucksList'], state);
const hdTrucksMilesListData = (state: any) => R.pathOr([], ['myproductivity', 'hdTrucksMilesList'], state);
const haulDistanceData = (state: any) => R.pathOr([], ['myproductivity', 'myHaulCycleList'], state);
const enableKomtraxPLus = (state: any) => R.pathOr([], ['myproductivity', 'enableKomtraxPLus'], state);
const enablePLM = (state: any) => R.pathOr([], ['myproductivity', 'enablePLM'], state);
const isKomtrax = (state: any) => R.pathOr([], ['myproductivity', 'isKomtrax'], state);

const selectors = {
    avgCycleTimeListData,
    avgCycleTimeListTotalData,
    myProductivityListData,
    mySwingloadOccurrenceListData,
    pmoTrucksListData,
    pmoTrucksMilesListData,
    hdTrucksListData,
    hdTrucksMilesListData,
    haulDistanceData,
    enableKomtraxPLus,
    enablePLM,
    isKomtrax
};

export default selectors;